import { HOST } from "../config";
import { FetchManager } from "../service/FetchManager";
import { Util } from "../util/Util";

const fetchManager = new FetchManager();

export class API {
  constructor() {}

  /**
   * @param {Object} form
   * @param {string} form.startDate - yyyy-mm-dd
   * @param {string} form.endDate - yyyy-mm-dd
   * @description 메인 API
   * @returns result
   */
  static getMainData = async (form) => {
    try {
      const url = `${HOST}/main`;
      const res = await fetchManager.get(url, form);
      const data = await Util.fetchAndSetData(res);

      if (data) return data.result;
      else throw new Error();
    } catch (e) {
      console.error("오류 발생", e);
      return null;
    }
  };

  /**
   * @param {Object} form
   * @param {string} form.startDate - yyyy-mm-dd
   * @param {string} form.endDate - yyyy-mm-dd
   * @description 상세 데이터 조회 API (기관별)
   * @returns result
   */
  static getDetailData = async (form) => {
    try {
      const url = `${HOST}/detail`;
      const res = await fetchManager.get(url, form);
      const data = await Util.fetchAndSetData(res);

      if (data) return data.result;
      else throw new Error();
    } catch (e) {
      console.error("오류 발생", e);
      return null;
    }
  };

  /**
   * @param {Object} form
   * @param {number} [form.departmentId]
   * @param {string} form.startDate - yyyy-mm-dd
   * @param {string} form.endDate - yyyy-mm-dd
   * @description 지역별 통계 조회 API
   * @returns result
   */
  static getStatsticRegion = async (form) => {
    try {
      const url = `${HOST}/statistic/region`;
      const res = await fetchManager.get(url, form);
      const data = await Util.fetchAndSetData(res);

      if (data) return data.result;
      else throw new Error();
    } catch (e) {
      console.error("오류 발생", e);
      return null;
    }
  };

  /**
   * @param {Object} form
   * @param {number} form.year - yyyy
   * @param {number} form.departmentId
   * @description 월별 포트홀 검출 현황 API
   * @returns result
   */
  static getMonthlyPotholeCount = async (form) => {
    try {
      const url = `${HOST}/pth-cnt/monthly`;
      const res = await fetchManager.get(url, form);
      const data = await Util.fetchAndSetData(res);

      if (data) return data.result;
      else throw new Error();
    } catch (e) {
      console.error("오류 발생", e);
      return null;
    }
  };

  /**
   * @description 당일 데이터 수신 현황 API
   * @returns result
   */
  static getDailyReceiveCount = async () => {
    try {
      const url = `${HOST}/receive-cnt/daily`;
      const res = await fetchManager.get(url);
      const data = await Util.fetchAndSetData(res);

      if (data) return data.result;
      else throw new Error();
    } catch (e) {
      console.error("오류 발생", e);
      return null;
    }
  };

  /**
   * @param {Object} form
   * @param {string} form.startDate - yyyy-mm-dd
   * @param {string} form.endDate - yyyy-mm-dd
   * @param {number[]} form.departmentIds
   * @description 기간별 데이터 수신 현황 API
   * @returns result
   */
  static getPeriodReceiveCount = async (form) => {
    try {
      // console.log("form", form);
      const url = `${HOST}/receive-cnt/filter`;
      const res = await fetchManager.post(url, form);
      const data = await Util.fetchAndSetData(res);

      if (data) return data.result;
      else throw new Error();
    } catch (e) {
      console.error("오류발생 ", e);
      return null;
    }
  };

  /**
   * @param {Object} form
   * @param {string} form.startDate - yyyy-mm-dd
   * @param {string} form.endDate - yyyy-mm-dd
   * @param {number[]} form.departmentIds
   * @description 기간별 데이터 수신 현황 API
   * @returns result
   */
  static getStatsticDevice = async (form) => {
    try {
      const url = `${HOST}/statistic/device`;
      const res = await fetchManager.post(url, form);
      const data = await Util.fetchAndSetData(res);

      if (data) return data.result;
      else throw new Error();
    } catch (e) {
      console.error("오류 발생", e);
      return null;
    }
  };
}
